module.exports = __webpack_public_path__ + "assets/da9e2d1d72e1c22d96a832894347a401.mp3";